import {Auth} from "../firebase/auth";
import {TemplatesWebFrontendRequest} from "services-comun-ed/modules/services/templates/frontend-web";
import {IComponentWindow} from "./interface";
import {RestablecerPassPopupController} from "./restablecer-pass";
import {UserHeaderController} from "./inicio";

export class AutenticacionPopupController {

    /* INSTANCE */
    public static instance: AutenticacionPopupController;
    private login?: IComponentWindow;

    /* STATIC */
    public static async build(auth: Auth): Promise<AutenticacionPopupController> {
        return AutenticacionPopupController.instance = new this(auth);
    }

    private constructor(readonly auth: Auth) {
        TemplatesWebFrontendRequest.loginPopup().then(async (response) => {
            const autenticacion = new DOMParser().parseFromString(response.data, 'text/html').body.firstChild as HTMLElement;
            this.login = {
                window: autenticacion,
                buttons: {
                    tab_login: autenticacion.querySelector(".tab-inicio-auth") as HTMLElement,
                    tab_signup: autenticacion.querySelector(".tab-registro-auth") as HTMLElement,
                    credentials: autenticacion.querySelector("#btn-login") as HTMLElement,
                    x: autenticacion.querySelector(".x-icon-auth") as HTMLElement,
                    facebook: autenticacion.querySelector(".facebook-icon-auth") as HTMLElement,
                    google: autenticacion.querySelector(".google-icon-auth") as HTMLElement,
                    show_password: autenticacion.querySelector(".eye-on-auth") as HTMLElement,
                    hide_password: autenticacion.querySelector(".eye-off-auth") as HTMLElement,
                },
                inputs: {
                    nombre: autenticacion.querySelector(".input-auth.nombre-auth") as HTMLInputElement,
                    email: autenticacion.querySelector(".input-auth.email-auth") as HTMLInputElement,
                    password: autenticacion.querySelector(".input-auth.password-auth") as HTMLInputElement,
                },
                containers: {
                    success: autenticacion.querySelector(".info-auth") as HTMLElement,
                    disclaimer_login: autenticacion.querySelector("#p2log") as HTMLElement,
                    disclaimer_signup: autenticacion.querySelector("#p2reg") as HTMLElement,
                    question_login: autenticacion.querySelector("#p3log") as HTMLElement,
                    question_signup: autenticacion.querySelector("#p3reg") as HTMLElement,
                    progress_bar: autenticacion.querySelector(".progress-bar-auth") as HTMLElement,
                }
            }
            await this.init();
            document.getElementsByTagName("body").item(0)?.appendChild(this.login!.window);
        });
    }

    private async init(): Promise<void> {
        this.login?.buttons?.show_password?.addEventListener("click", ()=>{
            this.login!.buttons!.show_password!.style.display = "none";
            this.login!.buttons!.hide_password!.style.display = "block";
            this.login?.inputs?.password?.setAttribute("type", "text");
        });
        this.login?.buttons?.hide_password?.addEventListener("click", ()=>{
            this.login!.buttons!.show_password!.style.display = "block";
            this.login!.buttons!.hide_password!.style.display = "none";
            this.login?.inputs?.password?.setAttribute("type", "password");
        });
        this.login?.inputs?.password?.addEventListener("keyup", (e) => {
            if (this.login?.containers?.progress_bar?.style.display !== "none" || getComputedStyle(this.login?.containers?.progress_bar).display !== "none") {
                this.setStrength();
            }
        });
        this.login?.containers?.disclaimer_login.addEventListener("click", async () => {
            const popup = await RestablecerPassPopupController.instance.getComponent();
            popup.window.style.display = "block";
            UserHeaderController.instance.createOverlay(popup.window);
            this.login!.window.style.display = "none";
        });
        this.login?.buttons?.tab_login?.addEventListener("click", this.signupActions.bind(this));
        this.login?.buttons?.tab_signup?.addEventListener("click", this.loginActions.bind(this));
        this.login?.containers?.question_signup.addEventListener("click", this.loginActions.bind(this));
        this.login?.containers?.question_login.addEventListener("click", this.signupActions.bind(this));
        this.login?.window.querySelector(".cerrar-login-mobile")?.addEventListener("click", () => {
            this.login!.window.style.display = "none";
            UserHeaderController.instance.destroyOverlay();
        });
        this.credentials();
        this.x();
        this.facebook();
        this.google();
    }

    public loginActions(): void {
        this.login?.buttons?.tab_signup?.classList.remove("inactiva-auth");
        this.login?.buttons?.tab_login?.classList.add("inactiva-auth");
        (<HTMLElement>document.querySelector(".texto-encabezado1-auth.signup-auth")).style.display = "block";
        (<HTMLElement>document.querySelector(".texto-encabezado1-auth.login-auth")).style.display = "none";
        (<HTMLElement>document.querySelector(".texto-encabezado2-auth.signup-auth")).style.display = "block";
        (<HTMLElement>document.querySelector(".texto-encabezado2-auth.login-auth")).style.display = "none";
        (<HTMLElement>document.querySelector(".pregunta1-auth.signup-auth")).style.display = "block";
        (<HTMLElement>document.querySelector(".pregunta1-auth.login-auth")).style.display = "none";
        (<HTMLElement>document.querySelector(".input-wrapper-nombre")).style.display = "inline-block";
        this.login!.containers!.question_login.style.display = "block";
        this.login!.containers!.question_signup.style.display = "none";
        this.login!.containers!.disclaimer_login.style.display = "none";
        this.login!.containers!.disclaimer_signup.style.display = "block";
        this.login!.containers!.progress_bar!.style.display = "block";
        this.login!.buttons!.credentials!.firstElementChild!.textContent = "Crear cuenta";
        this.login!.buttons?.credentials!.classList.remove("accion-login");
        this.login!.buttons?.credentials!.classList.add("accion-registro");
    }

    public signupActions(): void {
        this.login?.buttons?.tab_login?.classList.remove("inactiva-auth");
        this.login?.buttons?.tab_signup?.classList.add("inactiva-auth");
        (<HTMLElement>document.querySelector(".texto-encabezado1-auth.signup-auth")).style.display = "none";
        (<HTMLElement>document.querySelector(".texto-encabezado1-auth.login-auth")).style.display = "block";
        (<HTMLElement>document.querySelector(".texto-encabezado2-auth.signup-auth")).style.display = "none";
        (<HTMLElement>document.querySelector(".texto-encabezado2-auth.login-auth")).style.display = "block";
        (<HTMLElement>document.querySelector(".pregunta1-auth.signup-auth")).style.display = "none";
        (<HTMLElement>document.querySelector(".pregunta1-auth.login-auth")).style.display = "block";
        (<HTMLElement>document.querySelector(".input-wrapper-nombre")).style.display = "none";
        this.login!.containers!.question_login.style.display = "none";
        this.login!.containers!.question_signup.style.display = "block";
        this.login!.containers!.disclaimer_login.style.display = "block";
        this.login!.containers!.disclaimer_signup.style.display = "none";
        this.login!.containers!.progress_bar!.style.display = "none";
        this.login!.buttons!.credentials!.firstElementChild!.textContent = "Entrar";
        this.login!.buttons!.credentials!.classList.remove("accion-registro");
        this.login!.buttons!.credentials!.classList.add("accion-login");
    }

    private async credentials(): Promise<void> {
        this.login?.buttons?.credentials?.addEventListener("click", async () => {
            await this.auth?.accessWithCredentials(this.login!.inputs!.email!.value, this.login!.inputs!.password!.value, this.login!.buttons?.credentials?.classList.contains("accion-login")?"accion-login":"accion-registro", this.login!.inputs!.nombre!.value);
        });
    }

    private async x(): Promise<void> {
        this.login?.buttons?.x?.addEventListener("click", async () => {
            await this.auth?.accessWithX();
        });
    }

    private async facebook(): Promise<void> {
        this.login?.buttons?.facebook?.addEventListener("click", async () => {
            await this.auth?.accessWithFacebook();
        });
    }

    private async google(): Promise<void> {
        this.login?.buttons?.google?.addEventListener("click", async () => {
            await this.auth?.accessWithGoogle();
        });
    }

    private setStrength(): void {
        const strengthText = this.login!.inputs!.password!.value;
        let porcentaje = 0;
        let color = "ff9046";
        let indicador = "Débil";

        // Verificar longitud mínima
        if (strengthText.length >= 8) porcentaje += 20;

        // Verificar presencia de letras y números
        if (/\d/.test(strengthText) && /[a-zA-Z]/.test(strengthText)) porcentaje += 40;

        // Verificar presencia de al menos una letra mayúscula
        if (/[A-Z]/.test(strengthText)) porcentaje += 20;

        // Verificar presencia de al menos un carácter especial
        if (/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(strengthText)) porcentaje += 20;

        if (porcentaje >= 60) color = "afcf4b";
        if (porcentaje >= 60 && porcentaje <= 80) indicador = "Fuerte";
        if (porcentaje > 80) indicador = "Muy Fuerte";

        (<HTMLElement>this.login!.containers!.progress_bar!.firstElementChild).style.width = `${porcentaje}%`;
        (<HTMLElement>this.login!.containers!.progress_bar!.firstElementChild).style.backgroundColor = `#${color}`;
        (<HTMLElement>this.login!.containers!.progress_bar!.lastElementChild).textContent = `Seguridad: ${indicador}`;
    }

    public getComponent(): IComponentWindow {
        return this.login as IComponentWindow;
    }

}
